import * as React from 'react'

import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import { Card } from '@pareto-engineering/design-system'

import styleNames from '@pareto-engineering/bem/exports'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'use-case-card'

/**
 * This is the component description.
 */
const UseCaseCard = ({
  id,
  className:userClassName,
  image,
  style,
  title,
  path,
  description,
}) => {
  const Wrapper = path ? Link : 'div'

  return (
    <Wrapper
      id={id}
      className={[
        baseClassName,
        componentClassName,
        userClassName,
        path && 'clickable',
      ]
        .filter((e) => e)
        .join(' ')}
      style={style}
      to={path}
    >
      <div className="info">
        <img src={image} alt={title} />
        <p className="x-heading c-x h4">{title}</p>
        <p className="x-paragraph c-x">{description}</p>
      </div>
      {
        path && (
          <div className="path-link s-1">
            <span>Learn more</span>
            {' '}
            <span className="icon s-2 x-paragraph c-x">
              M
            </span>
          </div>
        )
      }
    </Wrapper>
  )
}

UseCaseCard.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * The title
   */
  title:PropTypes.string,

  /**
   * The description
   */
  description:PropTypes.string,

  /**
   * The image
   */
  image:PropTypes.string,

  /**
   * The path
   */
  path:PropTypes.string,
}

UseCaseCard.defaultProps = {
  //
}

UseCaseCard.Group = Card.Group

export default UseCaseCard
